module.exports = __webpack_public_path__ + "img/lotus.dabd7c40.svg";